import { getWidgetMeta } from 'core-components/sitebuilder/helpers/MetaSelector'
import { IFlexItem } from 'core-components/sitebuilder/models/flexGrid/IFlexItem'
import { IFlexLayout } from 'core-components/sitebuilder/models/flexGrid/IFlexLayout'
import { ISitePage } from 'core-components/sitebuilder/models/ISitePage'
import { IWidget } from 'core-components/sitebuilder/models/IWidget'
import { IWidgetsData } from 'core-components/sitebuilder/models/IWidgetData'

import { TWrap } from '../models/IWrap'

export const prepareDefaultState = (
  widget: IWidget,
  sitePage: ISitePage,
  flexSettings: IFlexLayout
) => {
  const redactorType = getWidgetMeta(widget.i).redactorType
  if (redactorType === 'cms') {
    const currentSettings = flexSettings[`${sitePage.id}-0`] || {}
    const defSettings = sitePage.defaultSettings[0] || {}
    const items = currentSettings.items?.length ? currentSettings.items : defSettings.items

    const allWidgets = [] as IFlexItem[]

    const getWidgetsFromWrapper = (items: IFlexItem[]) => {
      for (const el of items) {
        if (!el.isFlexLayout) {
          allWidgets.push(el)
        } else {
          el.layoutSet && getWidgetsFromWrapper(el.layoutSet.items)
        }
      }
    }
    getWidgetsFromWrapper(items)
    const cms = allWidgets.find((el: any) =>
      el.widgets.some((widget: any) => widget.id === widget.i)
    )
    if (cms && cms.customWidgetSettings.cmsData) {
      return cms.customWidgetSettings.cmsData
    }
  }
  return []
}

export const getWidgetData = (widget: IWidget, widgetsDataProps?: IWidgetsData[]) => {
  let widgetData
  if (widgetsDataProps) {
    widgetData = widgetsDataProps.find((value) => {
      return widget.i === value.i
    })
  }
  return widgetData
}

const checkCustomValue = (wrap: TWrap) => {
  if (wrap) {
    const { height } = wrap
    const defaultValues = [
      'auto',
      'calc(100vh - 64px - 50px)',
      'calc(100vh - 45px)',
      'calc(100vh - 45px - 100px)',
      '100vh',
      '75vh',
      '50vh',
      '25vh',
    ]
    return defaultValues.findIndex((h) => h === height)
  }
  return undefined
}
